import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { useRequest } from "ahooks";
import { MdCommentsDisabled } from "react-icons/md";
import { toast } from "react-toastify";
import "./Static.scss";
import MembershipIcon from "../../../common/membership/MembershipIcon";
import useGetMemberByStudent from "../../../hooks/useGetMemberByStudent";
import { ControlDialog } from "../../../components";
import MembershipDB from "../../../hooks/model/membership";

export default function StudentMembership({ studentId }) {
  const [openDelConfirm, setOpenDelConfirm] = useState(false);
  const { data, manualRefresh } = useGetMemberByStudent({ studentId });
  //   loading, data, refresh
  const membership = data?.data;

  const { loading: loadingDelete, run: runDeactivate } = useRequest(MembershipDB.deactivate, {
    manual: true,
    onSuccess: (res) => {
      if (res?.status) {
        toast.success(res?.message);
        setOpenDelConfirm(false);
        manualRefresh();
      }
    },
  });

  const handleDelete = () => {
    setOpenDelConfirm(true);
  };

  if (!membership) {
    return (
      <div className='no-membership-student-profile'>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}>
          <MembershipIcon
            size={25}
            className='membership-icon'
            style={{ color: "gray", backgroundColor: "White", borderRadius: 20 }}
          />
          <div className='membership-title'>No membership</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <ControlDialog
        open={openDelConfirm}
        setOpen={setOpenDelConfirm}
        title='Deactivate'
        type='delete'
        isLoading={loadingDelete}
        description={
          <div>
            <div>Do you want to deactivate membership?</div>
            <div style={{ color: "gray" }}>This action can&apos;t be undone.</div>
          </div>
        }
        handleYes={() => runDeactivate({ id: membership?.member_id })}
      />
      <div className='membership-container'>
        <Link
          to={`/membership-card/${membership?.member_id}`}
          style={{ color: "black", textDecoration: "none", flex: 1 }}
          target='_blank'
        >
          <div className='membership-student-profile' title='View membership'>
            <div
              style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}
            >
              <MembershipIcon size={25} className='membership-icon' />
              <div className='membership-title'>Membership - {membership?.duration}</div>
            </div>
            <div className='membership-expire'>
              Expire: {moment(membership?.expire_at).format("DD-MM-YYYY")}
            </div>
          </div>
        </Link>
        <Button
          className='membership-button-icon'
          color='error'
          variant='outlined'
          onClick={handleDelete}
          title='Deactivate'
        >
          <MdCommentsDisabled size={30} />
        </Button>
      </div>
    </>
  );
}
